// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"190fa45a","461":"3a4d209c","638":"0d32639d","726":"0facacfb","730":"da1848b5"}[chunkId] + ".chunk.js";
};